






































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
// import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";
import DateFormat from "@/utility/DateFormat";

@Component({})
export default class BaseCardSuketMultiple extends Vue {
  @Prop() readonly register!: string;
  @Prop() expandInput!: boolean;
  @Prop() loading!: boolean;
  @Prop() creatorUserId!: number | string;
  @Prop() contentData!: Array<Record<string, unknown>>;
  @Prop() title!: string;
  @Prop({ type: Boolean, default: false }) isReadOnly: boolean;
  @Prop({ type: String, default: "" }) readonly accessCode!: string;

  @Prop({ type: Boolean, default: true }) readonly allowAdd!: boolean;
  @Prop({ type: Boolean, default: false }) readonly removeByOwner!: boolean;
  @Prop({ type: Boolean, default: false }) readonly ttdBasah!: boolean;

  modalTtd = false;
  pageTab = "tab-soap";
  isBusy = false;

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get user() {
    return userModule.user;
  }

  terkunciBerkas(item): boolean {
    return !!item.is_finalized || Number(item.berkas_count || 0) > 0;
  }

  canEdit(item) {
    if (this.ttdBasah) {
      return (
        (this.user.id == item.dokter_id || this.user.id == item.creator_user_id) &&
        !item.is_signed &&
        !this.terkunciBerkas(item)
      );
    }
    return this.user.id == item.dokter_id && !item.is_signed;
  }

  canSign(item) {
    if (this.ttdBasah) return false;
    return this.user.id == item.dokter_id && !item.is_signed;
  }

  canRemove(item) {
    if (this.ttdBasah && this.terkunciBerkas(item)) return false;
    if (this.removeByOwner) {
      return this.user.id == item.creator_user_id || this.user.id == item.dokter_id;
    }
    return this.user.id == item.dokter_id && item.is_signed;
  }

  get canCreate() {
    if (this.accessCode && userModule.canAccessForm(this.accessCode, "create")) {
      return true;
    }
    return this.user.profesi === "Dokter";
  }

  get canAdd() {
    if (userModule.user.unit_id == "01" || userModule.user.unit_id > "35") {
      return this.canCreate;
    } else {
      return this.canCreate && this.statesoapdetail.length;
    }
  }

  getSignedDateTime(date) {
    return date ? DateFormat.formatDate(date) : null;
  }

  add() {
    this.$emit("add");
  }

  backPageSoap() {
    this.$emit("backPageSoap");
  }

  print(id) {
    this.$emit("print", id);
  }

  edit(item) {
    this.$emit("edit", item);
  }

  setActive(item) {
    this.$emit("setActive", item);
  }

  remove(item) {
    const q = confirm(`Hapus ${this.title} ini?`);

    if (q) {
      this.$emit("remove", item);
    }
  }

  showSignatureModal() {
    this.$emit("showSignatureModal");
  }
}
